import React, { memo, useMemo } from 'react';
import { TableCell } from '@mui/material';
import moment from 'moment';
import _ from 'lodash';

import { RenderCustomRowProps } from 'ui/components/Table/ItemsTable/types';
import { DateMessage } from 'ui/components/DateTooltip/types';
import { DateTooltip } from 'ui/components/DateTooltip';
import { User } from 'services/user';
import { TIMEZONES } from 'helpers/timezones';
import { useGetIntlDateFormatString } from 'helpers';

const UserRow: React.FC<RenderCustomRowProps<User>> = (props) => {
  const { row, columns } = props;

  const intlFormatDate = useGetIntlDateFormatString();

  const itemActive = useMemo(() => columns.length === 2, [columns]);

  const tooltipDates: DateMessage[] = useMemo(
    () => [
      { date: row.dateCreated, message: 'Date Created' },
      { date: row.dateLastModified, message: 'Date Last Modified' },
    ],
    [row]
  );

  const dateValue: string = useMemo(() => {
    const dateField = !itemActive ? columns[4].field! : null;
    const date = dateField ? _.get(row, dateField, null) : null;

    return date ? moment(date).format(intlFormatDate) : '';
  }, [columns, row, itemActive, intlFormatDate]);

  const timezone = useMemo(() => {
    if (!row.timezone) {
      return '';
    }

    const timezone = TIMEZONES.find((t) => t.utc.includes(row.timezone!));

    return timezone ? timezone.text : row.timezone;
  }, [row.timezone]);
  return (
    <>
      <TableCell>{_.get(row, 'firstName')}</TableCell>
      <TableCell>{_.get(row, 'lastName')}</TableCell>
      {!itemActive && (
        <>
          <TableCell>{timezone}</TableCell>
          <TableCell>{_.get(row, 'defaultLocation.displayName')}</TableCell>
          <DateTooltip values={tooltipDates}>
            <TableCell>{dateValue}</TableCell>
          </DateTooltip>
        </>
      )}
    </>
  );
};

export default memo(UserRow);
